export const ContestTime = new Date('2023-09-01T00:00:00.024Z')
export const ContestEndTime = new Date('2023-09-11T00:00:00.024Z')
export const HalloweenTime = new Date('2023-10-30T08:30:00.024Z')
export const HalloweenEndTime = new Date('2023-11-05T08:30:00.024Z')
export const DEFAULT_AVATAR =
  "https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250";